/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './organ-at-risk.reducer';

export const OrganAtRiskDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const organAtRiskEntity = useAppSelector(state => state.organAtRisk.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="organAtRiskDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.organAtRisk.detail.title">OrganAtRisk</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.organAtRisk.id">Id</Translate>
            </span>
          </dt>
          <dd>{organAtRiskEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.organAtRisk.name">Name</Translate>
            </span>
          </dt>
          <dd>{organAtRiskEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.organAtRisk.description">Description</Translate>
            </span>
          </dt>
          <dd>{organAtRiskEntity.description}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.organAtRisk.code">Code</Translate>
            </span>
          </dt>
          <dd>{organAtRiskEntity.code}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.organAtRisk.active">Active</Translate>
            </span>
          </dt>
          <dd>{organAtRiskEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.organAtRisk.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{organAtRiskEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.organAtRisk.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{organAtRiskEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.organAtRisk.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{organAtRiskEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.organAtRisk.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{organAtRiskEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.organAtRisk.radiationSession">Radiation Session</Translate>
          </dt>
          <dd>
            {organAtRiskEntity.radiationSessions
              ? organAtRiskEntity.radiationSessions.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {organAtRiskEntity.radiationSessions && i === organAtRiskEntity.radiationSessions.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/organ-at-risk" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/organ-at-risk/${organAtRiskEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OrganAtRiskDetail;
